var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rb__country-selector" },
    [
      !!_vm.value && _vm.value.iconFlag
        ? _c("rb-lazy-icon", {
            attrs: {
              icon: _vm.flagSelected.iconFlag,
              text: _vm.flagSelected.label,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "select",
        {
          staticClass: "rb__country-selector__selection",
          attrs: { "aria-label": "select-country" },
          on: {
            change: function ($event) {
              return _vm.onChange($event)
            },
          },
        },
        _vm._l(_vm.locales, function (locale, i) {
          return _c(
            "option",
            {
              key: i,
              domProps: {
                selected: _vm.getSelected(locale),
                value: locale.iconFlag,
              },
            },
            [_vm._v("\n      " + _vm._s(locale.label) + "\n    ")]
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }